import { defaultstaffRoute } from './defaultstaff';

export const allDefaultstaffRoutes = [defaultstaffRoute()];
